import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="Hayami-san es INVIDENTE parte 2"
      portada="https://fullcomics18.org/img7/hayami-san-es-invidente2-1.jpg"
    paginas={[
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-1.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-2.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-3.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-4.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-5.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-6.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-7.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-8.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-9.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-10.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-11.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-12.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-13.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-14.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-15.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-16.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-17.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-18.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-19.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-20.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-21.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-22.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-23.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-24.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-25.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-26.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-27.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-28.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-29.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-30.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-31.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-32.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-33.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-34.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-35.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-36.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-37.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-38.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-39.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente2-40.jpg"
]}
      sugeridos={[]}


      info={{
     grupo: "shoot the moon ",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["BBM", "Beauty Mark", "Big Ass", "Big Breasts", "Blind", "Bloomers", "Blowjob", "Cunnilingus", "Digital", "Drugs", "Glasses", "Gokkun", "Group", "Multi-work Series", "Nakadashi", "Netorare", "Paizuri", "Prostitution", "Smell", "Sole Female", "X-Ray"],
    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "Hayami-san es INVIDENTE parte 2",
  portada: "https://fullcomics18.org/img7/hayami-san-es-invidente2-1.jpg",
  reverso: "https://fullcomics18.org/img7/hayami-san-es-invidente2-3.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon ",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["BBM", "Beauty Mark", "Big Ass", "Big Breasts", "Blind", "Bloomers", "Blowjob", "Cunnilingus", "Digital", "Drugs", "Glasses", "Gokkun", "Group", "Multi-work Series", "Nakadashi", "Netorare", "Paizuri", "Prostitution", "Smell", "Sole Female", "X-Ray"],
    artistas: "Fuetakishi",
  },
};
